import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Frissítés ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline = _resolveComponent("headline")!
  const _component_separator = _resolveComponent("separator")!
  const _component_text_content = _resolveComponent("text-content")!
  const _component_cta_button = _resolveComponent("cta-button")!
  const _component_container = _resolveComponent("container")!
  const _component_advertising = _resolveComponent("advertising")!
  const _component_page = _resolveComponent("page")!

  return (_ctx.user && _ctx.vote && !_ctx.vote.isRunning)
    ? (_openBlock(), _createBlock(_component_page, {
        key: 0,
        is: "section",
        class: "vote-pending-page",
        "has-banner": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_container, { type: "section" }, {
            default: _withCtx(() => [
              _createVNode(_component_headline, { size: "large" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.vote.pending.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_separator),
              _createVNode(_component_text_content, {
                html: _ctx.vote.pending.text
              }, null, 8, ["html"]),
              _createElementVNode("p", null, [
                _createVNode(_component_cta_button, {
                  class: _normalizeClass(["vote-pending-page__refresh", {
            'vote-pending-page__refresh--refreshed': _ctx.voteItemRefreshed,
          }]),
                  theme: "primary",
                  loading: _ctx.voteItemFetcher.loading,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshVoteItem()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["class", "loading"])
              ])
            ]),
            _: 1
          }),
          (_ctx.vote.pending.advertising)
            ? (_openBlock(), _createBlock(_component_advertising, {
                key: 0,
                code: _ctx.vote.pending.advertising.code,
                image: _ctx.vote.pending.advertising.image,
                link: _ctx.vote.pending.advertising.link
              }, null, 8, ["code", "image", "link"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}